import Vue from 'vue';
import VueI18n from 'vue-i18n'
import store from "@/store";
Vue.use(VueI18n)

function loadLocalMessages(){
    const locales = require.context('./lang',true, /[A-Za-z0-9-_,\s]+\.json$/i) 

    let messages = {}
    locales.keys().forEach(key => {

        const matched = key.match(/([A-Za-z0-9-_]+)\./i)
        if(matched && matched.length > 1) {
            
            const locale = matched[1];
            messages[locale] = locales(key);
            import(`element-ui/lib/locale/lang/${locale}`).then(trans => {
                messages[locale] = {...messages[locale], ...trans.default }
              });
        }
    });     
    return messages;
}

export default new VueI18n({
    locale:store.getters.getCurrentLanguage ? store.getters.getCurrentLanguage : "en",
    fallbackLocale:'en',
    messages : loadLocalMessages()
})